import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, PropTypes } from 'react';
import styles from '../../../build/styles';

var Textarea =
/*#__PURE__*/
function (_Component) {
  _inherits(Textarea, _Component);

  function Textarea() {
    _classCallCheck(this, Textarea);

    return _possibleConstructorReturn(this, _getPrototypeOf(Textarea).apply(this, arguments));
  }

  _createClass(Textarea, [{
    key: "createControlClassName",
    value: function createControlClassName() {
      return [styles.control, styles[this.props.state], this.props.className].join(' ').trim();
    }
  }, {
    key: "createTextareaClassName",
    value: function createTextareaClassName() {
      return [styles.textarea, styles[this.props.color]].join(' ').trim();
    }
  }, {
    key: "renderHelp",
    value: function renderHelp() {
      if (!this.props.help) return null;
      return React.createElement('span', {
        className: [styles.help, styles[this.props.help.color]].join(' ')
      }, this.props.help.text);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('p', {
        className: this.createControlClassName(),
        style: this.props.style
      }, React.createElement('textarea', _extends({}, this.props, {
        style: {},
        className: this.createTextareaClassName(),
        disabled: this.props.state === 'isDisabled'
      })), this.renderHelp());
    }
  }]);

  return Textarea;
}(Component);

export { Textarea as default };
Textarea.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  hasIcon: PropTypes.bool,
  hasIconRight: PropTypes.bool,
  icon: PropTypes.string,
  type: PropTypes.string,
  color: PropTypes.oneOf(['isPrimary', 'isInfo', 'isSuccess', 'isWarning', 'isDanger']),
  state: PropTypes.oneOf(['isDisabled']),
  help: PropTypes.shape({
    text: PropTypes.string,
    color: PropTypes.oneOf(['isPrimary', 'isInfo', 'isSuccess', 'isWarning', 'isDanger'])
  })
};
Textarea.defaultProps = {
  style: {},
  className: ''
};